import { ENVS } from '../constants';

export const environments = {
  // Test enviroment is returned by default
  [ENVS.TEST]: {
    name: ENVS.TEST,
    optimizelyDebug: true,
    endpoints: {
      api: {
        url: '//api.dev.updater.com',
      },
      rest: {
        url: 'https://api-staging.verticalone.com/v1',
        headers: {
          'bypass-auth': true,
        },
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/PV8bgAg9tPhvowmGw4zz4X.json',
      cloudinary: 'https://res.cloudinary.com/updater-staging/image/upload',
    },
    keys: {
      segment: 'h07r7l3TCW1BsDnjaHUr7nlCmXFR4p9g',
    },
  },
  [ENVS.DEVELOPMENT]: {
    name: ENVS.DEVELOPMENT,
    endpoints: {
      api: {
        url: '//api.dev.updater.com',
      },
      rest: {
        url: 'https://api-staging.verticalone.com/v1',
        headers: {
          'bypass-auth': true,
        },
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/PV8bgAg9tPhvowmGw4zz4X.json',
      cloudinary: 'https://res.cloudinary.com/updater-staging/image/upload',
    },
    keys: {
      segment: 'h07r7l3TCW1BsDnjaHUr7nlCmXFR4p9g',
    },
  },
  [ENVS.DEMO]: {
    name: ENVS.DEMO,
    endpoints: {
      api: {
        url: '//api.staging.updater.com',
      },
      rest: {
        url: 'https://api-demo.verticalone.com/v1',
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/DnMhFQjARNtYrHoyJ6Dajb.json',
      cloudinary: 'https://res.cloudinary.com/updater-staging/image/upload',
    },
    keys: {
      segment: 'x7ja5i27N33qNsTvihiP7z1a8VEnSovw',
    },
  },
  [ENVS.STAGING]: {
    name: ENVS.STAGING,
    endpoints: {
      api: {
        url: '//api.staging.updater.com',
      },
      rest: {
        url: 'https://api-staging.verticalone.com/v1',
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/PYZ6JzCsWqvJNfFVhJAt4d.json',
      cloudinary: 'https://res.cloudinary.com/updater-staging/image/upload',
    },
    keys: {
      segment: 'h07r7l3TCW1BsDnjaHUr7nlCmXFR4p9g',
    },
  },
  [ENVS.PRODUCTION]: {
    name: ENVS.PRODUCTION,
    endpoints: {
      api: {
        url: '//api.updater.com',
      },
      rest: {
        url: 'https://api-production.verticalone.com/v1',
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/EGFQf1VKrjRj4FfMXSxb7L.json',
      cloudinary: 'https://res.cloudinary.com/updater-production/image/upload',
    },
    keys: {
      segment: 'GSFy6CR0gDV2PIy3XQYAOjcvSWGhLI1W',
    },
  },
  [ENVS.UPDATRON]: {
    name: ENVS.UPDATRON,
    endpoints: {
      api: {
        url: '//api.staging.updater.com',
      },
      rest: {
        url: 'https://api-staging.verticalone.com/v1',
      },
      optimizely:
        'https://cdn.optimizely.com/datafiles/PV8bgAg9tPhvowmGw4zz4X.json',
      cloudinary: 'https://res.cloudinary.com/updater-production/image/upload',
    },
    keys: {
      segment: 'GSFy6CR0gDV2PIy3XQYAOjcvSWGhLI1W',
    },
  },
};
